const arrayTObject = (items, key='id') => items.reduce((obj, item) => {
  obj[item[key]] = item;
  return obj
}, {}); //Vue.set(this.user, 'name', newName);updateDraft (state, value) {Object.assign(state.draft, value)},

const state = () => ({ status: '', logged: !!localStorage.getItem('autoken'), current: {} });

const getters = {
  isLogged: state => state.logged,
  statusOn: state => state.status,
  loggedAs: state => state.current,// isSilentMode: window.user_settings ? window.user_settings.get('isSilentMode') : false, // indicator: Number(Core.cookie.get('indicator', 0)), // countryId: typeof back_vars !== 'undefined' ? back_vars.countryId : 0,
};

const mutations = {
  SETATUS: (state, obj) => state.status = obj,
  SETOKEN: (state, obj) => {
    state.status = 'success'; state.logged = obj !== null;
    state.current = obj || {}; state.status = ''; //success | failure | pending
  }
};

const actions = {
  login: ({ commit },  payload) => {
    var params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', payload.username);
    params.append('password', payload.password);

    return new Promise(async (resolve, reject) => {
      commit('SETATUS', 'pending')
      try {
        const res = await window.api.post('oauth/token', params, {handlerr: true,
          auth: { username: 'ross-app', password: 'rossword' },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
        localStorage.setItem('autoken', res.data.access_token);
        commit('SETOKEN', res.data);
        resolve(res);
      } catch (err) {
        localStorage.removeItem('autoken');
        commit('SETATUS', 'failure');
        reject(err);
      }
    })
  },
  profile: async (context, payload) => {
    context.commit('SETATUS', 'pending')
    if(!context.getters.loggedAs.no) {
      try {
        const { data } = await window.api.get('oauth/profile');
        return context.commit('SETOKEN', data); 
      } catch (err) {
        return context.commit('SETATUS', 'failure');
      }
    }else if(payload) {
      try {
        const res = await window.api.put('oauth/profile/setting', payload);
        return context.commit('SETOKEN', res.data);
      } catch (err) {
        return context.commit('SETATUS', 'failure');
      }
    }
  },
  register: async ({ commit },  payload) => {
    return new Promise(async (resolve, reject) => {
      if(payload.token) {
        try{
          let res = await window.api.patch(
            'oauth/register/validate',
            null, {params: payload}
          ); resolve(res);
        } catch(err) {
          commit('SETATUS', 'failure');
          reject(err);
        }
      } else {
        commit('SETATUS', 'pending');
        try{
          let res = await window.api.post('oauth/register', payload);
          if(res.status === 200) commit('SETATUS', 'success');
          resolve(res);
        } catch(err) {
          commit('SETATUS', 'failure');
          reject(err);
        }
      }
    })
  },
  logout: ({commit}) => {
    commit('SETATUS', 'pending');
    setTimeout(() => {
      return new Promise(resolve => {
        localStorage.removeItem('autoken');
        commit('SETOKEN', null);
        resolve()
      })
    }, 500)
  },
};

const transact = {
  namespaced: true,
  state: () => ({ all: {} }),
  getters: {
    all: state => state.all,
    one: state => (id) => state.all[id],
  },
  mutations: {
    SET_TRANS: (state, obj) => state.all = arrayTObject(obj),
    ADD_TRANS: (state, obj) => state.all[obj.id] = obj,
    DEL_TRANS: (state, obj) => delete state.all[obj.id],
  },
  actions: {
    fetchTrans: async ({commit}) => {         
      try{
        let { data } = await window.api.get('operations');
        commit('SET_TRANS', data.content);
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    insertTrans: async (context, transact) => {
      try{
        let { status } = await window.api.post(`operations/${transact.type}s`, transact)
        if(status === 201) context.dispatch('profile', null, { root: true })
        context.commit('SETATUS', 'success', { root: true })
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    removeTrans: async ({ commit },  transact) => {
      try{
        let { status } = await window.api.delete(`operations/${transact.type}s/${transact.id}`)
        if(status === 204) commit('DEL_TRANS', transact);
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    updateTrans: async (context, transact) => {
      if (context.getters.one(transact.id)) {
        try{
          let { status } = await window.api.patch(`operations/${transact.type.toLowerCase()}s/${transact.id}`)
          if(status === 202) context.dispatch('profile', null, { root: true })
          context.commit('SETATUS', 'success', { root: true })
        } catch(err) {
          context.commit('SETATUS', 'failure', { root: true })
        }
      }
    },
    setatusTrans: async (context, transact) => {
      if (context.getters.one(transact.id)) {
        try{
          let { status } = transact.status==='PENDING'? await window.api.put(`operations/${transact.type.toLowerCase()}s/${transact.id}/progress`): await window.api.patch(`operations/${transact.type.toLowerCase()}s/${transact.id}/complete`)
          if(status === 202) context.dispatch('profile', null, { root: true })
          context.commit('SETATUS', 'success', { root: true })
        } catch(err) {
          context.commit('SETATUS', 'failure', { root: true })
        }
      }
    },
  }
};

const resource = {
  namespaced: true,
  state: () => ({ bonds: {one: {}, dvs: {}, all: []}, rates: [], tiers: [], users: {} }),
  getters: {
    BOND : state => state.bonds.one,
    BONDS : state => state.bonds.all,
    DEVI : state => state.bonds.dvs,
    one: state =>id => state.bonds.all.find(obj => obj.id === id),
    RATES : state => state.rates,
    rate: state => (id) => state.rates.find(obj => obj.id === id),
    TIERS : state => state.tiers,
    tier: state => (id) => state.tiers.find(obj => obj.id === id),
    USERS : state => state.users,
    user: state => (id) => state.users[id],
  },
  mutations: {
    SET_BOND : (state,obj) => state.bonds.all = obj,
    ADD_BOND : (state,obj) => state.bonds.one = obj,
    ADD_DEVI : (state,obj) => state.bonds.dvs = obj,
    DEL_BOND : (state,obj) => state.bonds.all.push(obj),

    SET_RATE : (state,obj) => state.rates = obj,
    ADD_RATE : (state,obj) => state.rates.push(obj),
    DEL_RATE : (state,obj) => state.rates.splice(obj, 1),

    SET_TIER : (state,obj) => state.tiers = obj,
    ADD_TIER : (state,obj) => state.tiers.push(obj),
    DEL_TIER : (state,obj) => state.tiers.splice(obj, 1),

    SET_USER: (state, obj) => state.users = arrayTObject(obj, 'no'),
    ADD_USER: (state, obj) => state.users[obj.id] = obj,
    DEL_USER: (state, obj) => delete state.users[obj.id],
  },
  actions: {
    fetchBond: async context => {
      if (!context.getters.BOND.id) {
        let { data } = await window.api.get('operations/bondast')
        context.commit('ADD_BOND', data || {})
      }
    },
    fetchDevi: async context => {
      if (!context.getters.DEVI.id) {
        let { data } = await window.api.get('operations/currate')
        context.commit('ADD_DEVI', data || {})
      }
    },
    insertBond: async ({ commit }, payload) => {
      try{
        let { data } = await window.api.get(`operations/bonds/${payload}/souscris`)
        commit('SET_BOND', data)
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    removeBond: async ({ commit }, payload) => {
      try{
        let res = await window.api.post(`operations/bonds/${payload.to.id}/souscris`, payload)
        if(res.status === 201) commit('DEL_BOND', res.data)
        commit('SETATUS', 'success', { root: true }) //return await window.api.post('/my/url/endpoint', payload).then(res => commit('SOME_MUTATION', res.data));
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    fetchRate: async context => {
      if(!context.getters.RATES.length)
      try{
        let { data } = await window.api.get('rates')
        context.commit('SET_RATE',data.content)
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    insertRate: async (context, payload) => {
      try{
        if (context.getters.rate(payload.id))
          return await window.api.put(`rates/${payload.id}`, payload);
        else {
          let res = await window.api.post('rates', payload)
          if(res.status === 201) context.commit('ADD_RATE', res.data)
          context.commit('SETATUS', 'success', { root: true })
        }
      } catch(err) {
        context.idcommit('SETATUS', 'failure', { root: true })
      }
    },
    removeRate: async ({ commit }, payload) => {
      try{
        let { status } = await window.api.delete(`users/${payload.id}`)
        if(status === 204) commit('DEL_RATE',payload)
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    fetchTier: async context => {
      if(!context.getters.TIERS.length)
      try{
        let { data } = await window.api.get('wallets/tiers')
        context.commit('SET_TIER', data)
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    insertTier: async (context, payload) => {
      try{
        if (context.getters.tier(payload.id))
          return await window.api.put(`wallets/tiers/${payload.id}`, payload);
        else {
          let res = await window.api.post('wallets/tiers', payload)
          if(res.status === 201) context.commit('ADD_TIER', res.data)
          context.commit('SETATUS', 'success', { root: true })
        }
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    removeTier: async ({ commit }, payload) => {
      try{
        let { status } = await window.api.delete(`wallets/tiers/${payload.id}`)
        if(status === 204) commit('DEL_TIER', payload)
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
    fetchUser: async context => {
      if(!Object.values(context.getters.USERS).length)
      try{
        let { data } = await window.api.get('wallets')
        context.commit('SET_USER', data.content);
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    insertUser: async (context, payload) => {
      try{
        if (context.getters.user(payload.no))
          return await window.api.put(`wallets/${payload.no}`, payload);
        else {
          let res = await window.api.post('wallets', payload)
          if(res.status === 201) context.commit('ADD_USER', res.data)
          context.commit('SETATUS', 'success', { root: true })
        }
      } catch(err) {
        context.commit('SETATUS', 'failure', { root: true })
      }
    },
    removeUser: async ({ commit }, payload) => {
      try{
        let { status } = await window.api.delete(`wallets/${payload.id}`)
        if(status === 204) commit('DEL_USER',payload)
      } catch(err) {
        commit('SETATUS', 'failure', { root: true })
      }
    },
  }
};

export default {
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  mutations,
  actions,
  modules: { transact, resource }
};
